<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Geräteberichte herunterladen"}}: {{title}}</h4>
</div>
<div class="modal-body">
    {{ERROR_ROW errors.error}}
</div>
<div class="js-download-table"></div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" data-dismiss="modal">{{TR "Schließen"}}</button>
</div>
